export enum AccordionEventKey {
  Opacity = 'opacity',
  LayerDetails = 'layer-details',
  Histogram = 'histogram',
  PointSize = 'point-size',
  PointShape = 'point-shape',
}

export enum PointShape {
  Square = 'square',
  Circle = 'circle',
}
